import { useEffect } from "react";

export function CookieConsentInit() {
  useEffect(() => {
    // Dynamically import the cookie consent module (and its CSS) so it
    // doesn't block the initial render or contribute to LCP.
    import("@/lib/cookieConsent")
      .then(({ initCookieConsent }) => {
        initCookieConsent();
      })
      .catch((error) => {
        console.error("Failed to load cookie consent module:", error);
      });
  }, []);

  return null;
}
